import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import useUser from "../../../hooks/useUser";

/**
 * Fetching a conversation's messages marks it as read on the backend,
 * so once they're loaded the cached conversation list and unread count are updated to match.
 * The count is only decremented if the conversation was actually unread in the list.
 */
export default function useMarkConvoAsRead(convoId, messagesLoaded = false) {
  const queryClient = useQueryClient();
  const { profile, roles, currentClinic } = useUser();
  const countKey = roles.adminOrEmployee
    ? "convo_count" + currentClinic?.id
    : "convo_count" + profile?.id;

  useEffect(() => {
    if (!messagesLoaded || convoId == null) return;

    const convos = queryClient.getQueryData(["conversations"]);
    const convo = convos?.find((c) => Number(c?.id) === Number(convoId));

    if (!convo || convo.read) return;

    queryClient.setQueryData(["conversations"], (old) =>
      old?.map((c) =>
        Number(c?.id) === Number(convoId) ? { ...c, read: true } : c
      )
    );
    queryClient.setQueryData([countKey], (old) =>
      typeof old === "number" ? Math.max(0, old - 1) : old
    );
  }, [convoId, messagesLoaded, countKey, queryClient]);
}
